/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Testimonial_3_AuthorInputs */

const en_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const es_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const de_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const zh_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const ar_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const fr_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const vi_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const sw_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const th_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const bs_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const ja_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const ko_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const pt_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const it_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const sv_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const nl_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const da_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const nb_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const fi_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const pl_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const ru_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const tr_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const hi_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const id_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const ms_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const cs_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const el_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const he_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const af_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

const hu_home_testimonial_3_author = /** @type {(inputs: Home_Testimonial_3_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenny M.`)
};

/**
* | output |
* | --- |
* | "Jenny M." |
*
* @param {Home_Testimonial_3_AuthorInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_testimonial_3_author = /** @type {((inputs?: Home_Testimonial_3_AuthorInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Testimonial_3_AuthorInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_testimonial_3_author(inputs)
	if (locale === "de") return de_home_testimonial_3_author(inputs)
	if (locale === "zh") return zh_home_testimonial_3_author(inputs)
	if (locale === "ar") return ar_home_testimonial_3_author(inputs)
	if (locale === "fr") return fr_home_testimonial_3_author(inputs)
	if (locale === "vi") return vi_home_testimonial_3_author(inputs)
	if (locale === "sw") return sw_home_testimonial_3_author(inputs)
	if (locale === "th") return th_home_testimonial_3_author(inputs)
	if (locale === "bs") return bs_home_testimonial_3_author(inputs)
	if (locale === "ja") return ja_home_testimonial_3_author(inputs)
	if (locale === "ko") return ko_home_testimonial_3_author(inputs)
	if (locale === "pt") return pt_home_testimonial_3_author(inputs)
	if (locale === "it") return it_home_testimonial_3_author(inputs)
	if (locale === "sv") return sv_home_testimonial_3_author(inputs)
	if (locale === "nl") return nl_home_testimonial_3_author(inputs)
	if (locale === "da") return da_home_testimonial_3_author(inputs)
	if (locale === "nb") return nb_home_testimonial_3_author(inputs)
	if (locale === "fi") return fi_home_testimonial_3_author(inputs)
	if (locale === "pl") return pl_home_testimonial_3_author(inputs)
	if (locale === "ru") return ru_home_testimonial_3_author(inputs)
	if (locale === "tr") return tr_home_testimonial_3_author(inputs)
	if (locale === "hi") return hi_home_testimonial_3_author(inputs)
	if (locale === "id") return id_home_testimonial_3_author(inputs)
	if (locale === "ms") return ms_home_testimonial_3_author(inputs)
	if (locale === "cs") return cs_home_testimonial_3_author(inputs)
	if (locale === "el") return el_home_testimonial_3_author(inputs)
	if (locale === "he") return he_home_testimonial_3_author(inputs)
	if (locale === "af") return af_home_testimonial_3_author(inputs)
	if (locale === "hu") return hu_home_testimonial_3_author(inputs)
	return en_home_testimonial_3_author(inputs)
});